// Lightweight regex-based parser for common Indonesian WA order formats.
const grab = (text, patterns) => {
  for (const p of patterns) {
    const m = text.match(p);
    if (m && m[1]) return m[1].trim().replace(/\s+/g, " ");
  }
  return "";
};

export function regexParse(text) {
  const name = grab(text, [
    /(?:nama penerima|penerima|nama)\s*:?\s*(.+)/i,
  ]);
  const phoneRaw = grab(text, [
    /(?:no\.?\s*hp|no\.?\s*telp|telp|hp|wa|whatsapp)\s*:?\s*([\d\s().+-]{8,})/i,
  ]);
  const phone = (phoneRaw || (text.match(/(0\d[\d\s().-]{7,})/) || [])[1] || "")
    .replace(/[^\d+]/g, "");
  const address = grab(text, [
    /(?:alamat lengkap|alamat|kirim ke|dikirim ke)\s*:?\s*([\s\S]+?)(?:\n(?:ekspedisi|kurir|pake|barang|isi|pesanan|catatan|cod|no)|$)/i,
  ]);
  const courier = grab(text, [
    /(?:ekspedisi|kurir|pake|pakai)\s*:?\s*(.+)/i,
  ]);
  const items = grab(text, [
    /(?:barang|isi|pesanan|order)\s*:?\s*(.+)/i,
  ]);
  const notes = grab(text, [/(?:catatan|note|notes)\s*:?\s*(.+)/i]);
  const code = grab(text, [/(?:no\.?\s*pesanan|kode pesanan|resi|invoice|inv)\s*:?\s*([A-Za-z0-9-]+)/i]);
  const cod = grab(text, [/cod\s*:?\s*(?:rp)?\s*([\d.,]+)/i]).replace(/[.,]/g, "");

  return {
    recipient_name: name,
    phone,
    address,
    courier: courier.replace(/\s*(aja|ya|saja)\s*$/i, "").trim(),
    items,
    notes,
    code,
    cod,
  };
}

export const emptyLabel = () => ({
  recipient_name: "",
  phone: "",
  address: "",
  courier: "",
  items: "",
  notes: "",
  code: "",
  cod: "",
});
